import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import createAxiosInstance from './utils/axios'
import VueCookie from 'vue-cookie'
import {Toast, Switch, Popup, CascadePicker} from 'cube-ui'
Vue.use(Toast)
Vue.use(Switch)
Vue.use(Popup)
Vue.use(CascadePicker)

Vue.use(VueCookie)

Vue.config.productionTip = false

window.axios = createAxiosInstance();

// 路由钩子
router.beforeEach((to, from, next) => {
	next();
});

router.afterEach((to, from) => {
	document.title = to.meta.displayName || '平安健康险';
	store.commit('preRoute', from);
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
